var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 2052",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 64,
    viewBox: "0 0 76 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rt0knt0zya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5155",
    style: {
      fill: "none"
    },
    d: "M0 0h76v64H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qgubom0rwb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 862",
    d: "M297 125.946v27.312h23.516a2.422 2.422 0 0 0 2.422-2.422v-22.468a2.422 2.422 0 0 0-2.422-2.422z",
    transform: "translate(-297 -125.946)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "efuw461coc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 864",
    d: "M38.422 86.588A2.422 2.422 0 0 0 36 89.01v29.184a2.422 2.422 0 0 0 2.422 2.422H79V86.588z",
    transform: "translate(-36 -86.588)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jabysgrxcd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 866",
    d: "M164.422 0A2.422 2.422 0 0 0 162 2.423v46.382h30.716V2.423A2.422 2.422 0 0 0 190.294 0z",
    transform: "translate(-162 -.001)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2053"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2052",
    style: {
      clipPath: "url(#rt0knt0zya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 861",
    d: "M297 125.945h23.326a2.41 2.41 0 0 1 2.4 2.418v22.427a2.41 2.41 0 0 1-2.4 2.418H297z",
    transform: "translate(-246.728 -104.493)",
    style: {
      fill: "#ffa85d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2055"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2054",
    style: {
      clipPath: "url(#qgubom0rwb)"
    },
    transform: "translate(50.062 21.423)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5156",
    transform: "translate(-.873 -4.022)",
    style: {
      fill: "#ff9839"
    },
    d: "M0 0h12.969v39.775H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2057"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2056",
    style: {
      clipPath: "url(#rt0knt0zya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 863",
    d: "M78.655 120.553H38.4a2.41 2.41 0 0 1-2.4-2.418V89a2.41 2.41 0 0 1 2.4-2.418h40.255z",
    transform: "translate(-29.906 -71.839)",
    style: {
      fill: "#dfebfa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2059"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2058",
    style: {
      clipPath: "url(#efuw461coc)"
    },
    transform: "translate(6.143 14.718)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5158",
    transform: "translate(-6.143 -7.836)",
    style: {
      fill: "#b1dbfc"
    },
    d: "M0 0h12.286v49.7H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2061"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2060",
    style: {
      clipPath: "url(#rt0knt0zya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 865",
    d: "M162 48.715V2.418A2.41 2.41 0 0 1 164.4 0h25.663a2.41 2.41 0 0 1 2.4 2.418v46.3z",
    transform: "translate(-134.579)",
    style: {
      fill: "#fee55a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2063"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2062",
    style: {
      clipPath: "url(#jabysgrxcd)"
    },
    transform: "translate(27.271)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5160",
    transform: "translate(-22.1 .095)",
    style: {
      fill: "#ffd303"
    },
    d: "M0 0h31.047v48.789H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2065"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2070"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 867",
    d: "M244.91 71.985h-2.778v-9.974h-1.056V59.4h3.835z",
    transform: "translate(-200.27 -49.278)",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 868",
    d: "M380.029 176.512v1.913c0 1.831-1.219 2.91-3.737 2.91s-3.737-1.079-3.737-2.91v-1.112h2.778v.736c0 .54.341.687.958.687s.959-.147.959-.687v-1.308c0-.54-.276-.769-.812-.769h-1.527v-2.616h1.527c.471 0 .666-.147.666-.605v-1c0-.474-.276-.7-.813-.7s-.812.229-.812.7v.376H372.7v-.916c0-1.848 1.446-2.78 3.591-2.78s3.591.932 3.591 2.78v1.6a1.981 1.981 0 0 1-1.072 1.782 1.892 1.892 0 0 1 1.219 1.913",
    transform: "translate(-309.494 -139.745)",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 869",
    d: "M82.939 129.628v-3.319a2.723 2.723 0 0 1 1.089-2.453l2.843-2.175a1.407 1.407 0 0 0 .471-1.112c0-.687-.276-1.079-.812-1.079s-.812.441-.812 1.226h-2.779c0-2.632 1.462-3.843 3.591-3.843 2.145 0 3.591 1.21 3.591 3.7a3.882 3.882 0 0 1-1.4 3.352l-2.632 1.929a.9.9 0 0 0-.374.687v.491h4.4v2.6z",
    transform: "translate(-68.9 -96.967)",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 870",
    d: "M128.957 235.3a12.273 12.273 0 1 1-12.273-12.351 12.312 12.312 0 0 1 12.273 12.351",
    transform: "translate(-86.738 -184.976)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 871",
    d: "M32.577 52.973a.879.879 0 0 1-.877-.882v-2.205a.877.877 0 1 1 1.753 0v2.205a.879.879 0 0 1-.877.882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 872",
    d: "M35.645 51.65a.879.879 0 0 1-.877-.882v-2.205a.877.877 0 1 1 1.753 0v2.205a.88.88 0 0 1-.877.882"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 873",
    d: "M129.938 308.906c.857.787 1.23 1.779.834 2.217s-1.413.154-2.27-.633-1.23-1.779-.834-2.217 1.413-.154 2.27.633",
    transform: "translate(-105.927 -255.593)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 874",
    d: "M132.528 329.623c.857.787 1.23 1.779.834 2.217s-1.413.154-2.27-.633-1.23-1.779-.834-2.217 1.413-.154 2.27.633",
    transform: "translate(-108.079 -272.782)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 875",
    d: "M155.834 329.623c.857.787 1.23 1.779.834 2.217s-1.413.154-2.27-.633-1.23-1.779-.834-2.217 1.413-.154 2.27.633",
    transform: "translate(-127.44 -272.782)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 876",
    d: "m140.665 159.631 4.383 7.5 4.822-7.94a6.724 6.724 0 0 0-4.822-1.323c-2.63.441-4.383.882-4.383 1.764",
    transform: "translate(-116.855 -130.919)",
    style: {
      fill: "#00dd4d"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 877",
    d: "M30.056 36.873c-.185 0-.365.021-.548.028v-.469c.018-.028.042-.049.059-.078l4.06-7.278a.888.888 0 0 0 .078-.2 1.38 1.38 0 0 0 .181-.678c0-1.739-3-2.356-5.563-2.356s-5.563.617-5.563 2.356a1.381 1.381 0 0 0 .18.677.879.879 0 0 0 .078.2l4.062 7.3a1.487 1.487 0 0 0 .237.306v.475a13.472 13.472 0 1 0 2.74-.283m-1.734-9.263a8.958 8.958 0 0 1 3.577.591 11.106 11.106 0 0 1-7.155 0 8.959 8.959 0 0 1 3.577-.591m-2.6 2.718a14.81 14.81 0 0 0 5.193 0l-2.217 3.974a.437.437 0 0 1-.765 0zm4.332 31.467a11.359 11.359 0 0 1-2.74-22.364v.75a1.1 1.1 0 1 0 2.192 0v-1.073c.183-.009.363-.028.548-.028a11.358 11.358 0 0 1 0 22.716"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 878",
    d: "M34.248 57.163a2.513 2.513 0 0 1-.906-.17 2.831 2.831 0 0 1-1.688-1.917.877.877 0 1 1 1.687-.482 1.092 1.092 0 0 0 .628.751.769.769 0 0 0 .711-.078c.271-.172.527-.335.527-1.413a.877.877 0 1 1 1.753 0 3 3 0 0 1-1.343 2.9 2.546 2.546 0 0 1-1.368.4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCreate);
export default __webpack_public_path__ + "static/media/group_create.a694737b52e7134b50dfd2721193ec97.svg";
export { ForwardRef as ReactComponent };